import { Component, Vue } from 'vue-property-decorator';
import { Getter } from 'vuex-class';

import { HAS_ANCHOR_BAR } from '@/store/getters';

import { TitleTextHeaderBlockViewModel } from './TitleTextHeaderModule.types';
import { getComponentProps } from '@/utils/vueUtils';

import ResponsiveImage from '@/components/ResponsiveImage/ResponsiveImage.vue';
import { ImageSizes, ImageSize } from '@/common/interfaces/SizeBreakpoints';

import { getResizeImage } from '@/utils/commonUtils';

const TitleTextHeaderModuleProps = Vue.extend({
  props: getComponentProps<TitleTextHeaderBlockViewModel>({
    Title: 'The Expedition Team',
    Text:
      "Lindblad Expeditions are helmed by some of the world's foremost adventurers. Seasoned captains, naturalists, historians, divers and expedition leaders who'll take you closer to remarkable worlds.",
    Image: { Url: getResizeImage('team-2.jpg'), Alt: 'The Team' },
  }),
});

@Component({
  components: {
    ResponsiveImage,
  },
})
export default class TitleTextHeaderModule extends TitleTextHeaderModuleProps {
  @Getter(HAS_ANCHOR_BAR) hasAnchorBar!: boolean;

  imageSizes: ImageSizes = {
    def: new ImageSize([1442, 675]),
    sizes: {
      sm: new ImageSize([375, 216]),
      md: new ImageSize([768, 550]),
      xl: new ImageSize([1442, 675]),
    },
  };
}
